import { AgGridColumnsSettingService } from './../ag-grid-columns-setting/ag-grid-columns-setting.service';
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ColDef, ColumnApi, ColumnResizedEvent, ColumnState, ComponentStateChangedEvent, DragStartedEvent, DragStoppedEvent, GridApi, GridOptions, GridSizeChangedEvent, RowClassRules, RowHeightParams, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridI, AgGridPaginationConfig, PaginationBaseModel, SaveUserSetting, TablePaginationModel, TablePaginationModelContact, TablePaginationModelVendorList } from './ag-grid.model';
import { AgGridService } from './ag-grid.service';
import { BehaviorSubject, Observable, Subject, Subscription, catchError, debounceTime, takeUntil } from 'rxjs';
import { Result } from '../../model/response.model';
import { UserSetting } from '../../../../app/components/crm/crm.model';
import { StorageService } from '../../services/storage.service';
import { TabsService } from '../tabs/tabs.service';
import { Router } from '@angular/router';
import { CodeCrosswalkService } from '../../../../app/components/admin/code-crosswalk/code-crosswalk.service';
import { RequirementsService } from '../../../../app/components/sales/requirements/pages/requirements/requirements.service';
import { CurrentTab, EnfoRoutePath, RoutePath, TabNames } from '../../model/enum';
import { GridName } from '../../../shared/model/ag-grid-common-constant'
import { Pagination } from '../../model/pagination.model';
import { AgGridResponsiveService } from '../../services/ag-grid-responsive.service';
declare var window: any;

@Component({
  selector: 'app-ag-grid',
  templateUrl: './ag-grid.component.html',
  styleUrls: ['./ag-grid.component.scss']
})
export class AgGridComponent implements OnInit {
  @Input() getRowStyle: any;
  @Input() dataModel: AgGridI;
  @Input() AgGridColumnsSettingComponent: boolean = false;
  @Input() tableRowCellEditable: boolean = true;
  private gridColumnApi!: ColumnApi;
  @Output() gridApiEmit = new EventEmitter();
  @Output() onHeaderAddClick: EventEmitter<any> = new EventEmitter();
  @Output() expandableIconClick: EventEmitter<any> = new EventEmitter();
  @Input() footerHeight: string = '';
  paramsData: any;
  isLoading: boolean = false;
  subscription: Subscription;
  @Input() tableId: string;
  @Input() columnSettings: boolean = true;
  @Input() handleCustomHeaderDisplay: boolean = true;
  @Input() paginations: boolean = true;
  @Input() gridOptions!: GridOptions;
  @Input() rowData: any[] = [];
  @Input() rowHeight = 28;
  @Input() headerHeight = 28;
  pagination = new Pagination();
  noRowsTemplate = `<span style="font-size:16px" No Record Found</span>`;
  userSetting = new UserSetting();
  saveUserSetting = new SaveUserSetting();
  paginationBaseModel = new PaginationBaseModel();
  tablePaginationModel = new TablePaginationModel();
  agGridPaginationConfig = new AgGridPaginationConfig();
  tablePaginationModelContact = new TablePaginationModelContact();
  tablePaginationModelVendorList = new TablePaginationModelVendorList();
  @Output("pageSizeChanged") pageSizeChanged: EventEmitter<any> = new EventEmitter();
  @Output("pageChanged") pageChanged: EventEmitter<any> = new EventEmitter();
  @Output() onRowClick: EventEmitter<any> = new EventEmitter();
  @Output() rowDoubleClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() gridReady: EventEmitter<any> = new EventEmitter();
  @Output() onPagination: EventEmitter<Pagination> = new EventEmitter();
  @Output() onPageSizeUpdated: EventEmitter<number> = new EventEmitter();
  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter();
  @Output() onTextCellClick: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteIconClick: EventEmitter<any> = new EventEmitter();
  @Output() onInputChangeClick: EventEmitter<any> = new EventEmitter();
  @Output() onImageIconClick: EventEmitter<any> = new EventEmitter();
  @Output() onSerialNumberClick: EventEmitter<any> = new EventEmitter();
  @Output() onLinkCellClick: EventEmitter<any> = new EventEmitter();
  @Output() onEditIconClick: EventEmitter<any> = new EventEmitter();
  @Output() onRatingIconClick: EventEmitter<any> = new EventEmitter();
  @Output() onSwitchIconClick: EventEmitter<any> = new EventEmitter();
  @Output() onSplitLineClick: EventEmitter<any> = new EventEmitter();
  @Output() onSelectOptionClick: EventEmitter<any> = new EventEmitter();
  @Output() onCreatePartClick: EventEmitter<any> = new EventEmitter();
  @Output() onApproveAltClick: EventEmitter<any> = new EventEmitter();
  @Output() onAddExchangeRateClick: EventEmitter<any> = new EventEmitter();
  @Output() onResultActionClick: EventEmitter<any> = new EventEmitter();
  @Output() onLineStatusClick: EventEmitter<any> = new EventEmitter();
  @Output() onAddRFQClick: EventEmitter<any> = new EventEmitter();
  @Output() onRemoveRFQClick: EventEmitter<any> = new EventEmitter();
  @Output() onConfirmPriorityQty: EventEmitter<any> = new EventEmitter();
  @Output() onToggleApproveChange: EventEmitter<any> = new EventEmitter();

  enumTabNames = TabNames;
  isRowDrag = false;
  deviceWidth: any;
  customizer = '';
  gridName = GridName;
  public components: { [p: string]: any } = {};

  isInitialCall: boolean = false;

  defaultColDefination: ColDef = {
    flex: 1,
    minWidth: 0,
    editable: false,
    resizable: true,
  };
  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 0,
    editable: true,
    resizable: true,
    singleClickEdit: true,
  };

  previousTabData: any[] = [];
  currentTabData: any[] = [];
  currentTab = '';
  currentUrl: string;
  searchTextCodeCrossWalk: string;
  overlayNoRowsTemplate = '<div class="ag-overlay-no-rows-center font-16">No Records Available</div>';
  gridApi: GridApi;
  routePath = RoutePath;
  tabName = CurrentTab;
  companyD = EnfoRoutePath;
  screenWidth$ = new BehaviorSubject<number>(window.innerWidth);

  // ─── State management flags ───────────────────────────────────────────────
  isRestoringState = false;
  isApplyingColumnDefs = false;

  // KEY: stores the last successfully restored/saved column state in memory.
  // Every time setColumnDefs() runs (recalculateColumnWidth), this is
  // re-applied so the user's column order is never lost.
  private lastRestoredState: ColumnState[] | null = null;

  private columnStateChange$ = new Subject<void>();
  private destroy$ = new Subject<void>();
  private recalculateColumnWidth$ = new Subject<void>();

  // Stores bound event listener refs so we can remove them in ngOnDestroy
  private boundHandlers: { event: string; handler: EventListener }[] = [];

  idsToDelete: any[] = [];
  returnMessage: any;
  totalrecord: number;

  constructor(
    public agGridService: AgGridService,
    public storageService: StorageService,
    public agGridColumnsSettingService: AgGridColumnsSettingService,
    public tabService: TabsService,
    public codeCrosswalkService: CodeCrosswalkService,
    public requirementsService: RequirementsService,
    public route: Router,
    private cdr: ChangeDetectorRef,
    private responsiveService: AgGridResponsiveService
  ) {
    this.getScreenWidth().subscribe((res) => {
      this.deviceWidth = res;
    });
  }

  ngOnInit(): void {
    this.columnSettings;
    this.prepareStorages();
    this.totalrecord = 100;
    this.agGridService.dataInput.next(this.dataModel.storageName);

    this.agGridColumnsSettingService.isCustomizerLayoutOpen.subscribe(res => {
      if (res.storageName === this.dataModel?.storageName) {
        this.customizer = res.state;
      }
    });

    // Debounce recalculate — collapses multiple rapid calls (resize events)
    // into a single setColumnDefs call, then re-applies lastRestoredState
    this.recalculateColumnWidth$
      .pipe(debounceTime(150), takeUntil(this.destroy$))
      .subscribe(() => this.doRecalculateColumnWidth());

    // Debounce save — waits for user to finish dragging before persisting
    this.columnStateChange$
      .pipe(debounceTime(600), takeUntil(this.destroy$))
      .subscribe(() => this.persistColumnState());

    // Sync column state and persist changes when modified in the setting sidebar
    this.agGridColumnsSettingService.columnOrderChanged
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (res && res.storageName === this.dataModel?.storageName) {
          this.lastRestoredState = res.columnState;
          this.columnStateChange$.next();
        }
      });
  }

  prepareStorages() {
    if (this.dataModel.colDefs) {
      this.dataModel.colDefs = this.dataModel?.colDefs.map((item, index) => ({
        ...item,
        headerComponentParams: {
          ...item.headerComponentParams,
          storageName: item?.headerComponentParams?.storageName == undefined
            ? this.dataModel?.storageName
            : item?.headerComponentParams?.storageName,
        },
      }));
    }
    // Ensure storageName is available in context for cell renderers and other components
    if (this.dataModel?.storageName && !this.dataModel?.context) {
      this.dataModel.context = {};
    }
    if (this.dataModel?.context && this.dataModel?.storageName) {
      this.dataModel.context.storageName = this.dataModel?.storageName;
    }
  }

  async onGridReady(params) {
    // Register all document event listeners via helper so they're
    // tracked and cleaned up in ngOnDestroy
    this.addGridEventListener('textCellClick', this.handleTextCellClick);
    this.addGridEventListener('deleteButtonClick', this.handleDeleteButtonClick);
    this.addGridEventListener('inputChangeClick', this.handleInputChangeClick);
    this.addGridEventListener('imageIconClick', this.handleImageIconClick);
    this.addGridEventListener('serialNumberClick', this.handleSerialNumberClick);
    this.addGridEventListener('linkCellClick', this.handleLinkCellClick);
    this.addGridEventListener('editIconClick', this.handleEditIconClick);
    this.addGridEventListener('ratingIconClick', this.handleRatingIconClick);
    this.addGridEventListener('switchIconClick', this.handleSwitchIconClick);
    this.addGridEventListener('splitLineClick', this.handleSplitLineClick);
    this.addGridEventListener('selectOptionClick', this.handleSelectOptionClick);
    this.addGridEventListener('createPartClick', this.handleCreatePartClick);
    this.addGridEventListener('approveAltClick', this.handleApproveAltClick);
    this.addGridEventListener('addExchangeRateClick', this.handleAddExchangeRateClick);
    this.addGridEventListener('resultActionClick', this.handleResultActionClick);
    this.addGridEventListener('lineStatusClick', this.handleLineStatusClick);
    this.addGridEventListener('addRFQClick', this.handleAddRFQClick);
    this.addGridEventListener('removeRFQClick', this.handleRemoveRFQClick);
    this.addGridEventListener('confirmPriorityQty', this.handleConfirmPriorityQty);
    this.addGridEventListener('toggleApproveChange', this.handleToggleApproveChange);

    this.rowData = this.rowData ?? [];
    this.agGridService.setGridApi(params);
    this.agGridService.setGridColumnApi(params.columnApi);
    this.paramsData = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // sizeChange runs synchronously — triggers recalculateColumnWidth$ subject.
    // With debounce(150) it will fire ~150ms later, BEFORE restoreColumnState
    // API call returns (which takes 200-900ms per network tab).
    this.sizeChange({ target: window });

    if (GridName.CODECROSSWALK == this.dataModel?.storageName) {
      this.initDatatable();
    }

    this.gridReady.emit(params);
    await this.paginationCall();
    this.gridApiEmit.emit(params.api);
    this.noRowsTemplate = `<span style="font-size:16px">No Record Found</span>`;

    // Restore runs after a short delay to ensure setColumnDefs from
    // recalculateColumnWidth has already been dispatched to the subject.
    // 200ms > debounce(150ms) so recalculate always completes first.
    setTimeout(() => this.restoreColumnState(), 200);
  }

  // ─── Document event listener helpers ─────────────────────────────────────

  private addGridEventListener(event: string, handler: Function): void {
    const bound = handler.bind(this) as EventListener;
    document.addEventListener(event, bound);
    this.boundHandlers.push({ event, handler: bound });
  }

  // ─── Column state: restore ────────────────────────────────────────────────

  private restoreColumnState(): void {
    if (!this.dataModel?.storageName) {
      return;
    }

    this.isRestoringState = true;

    this.agGridService
      .getAllsavedcolumnDefinitions(this.dataModel.storageName)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          try {
            const colState: ColumnState[] = JSON.parse(res.response?.colState ?? '[]');

            if (colState?.length) {
              // Sanitize: clear flex on non-spacer columns so it doesn't
              // fight explicit width values on restore
              const sanitized = colState.map(col => {
                const column = this.gridColumnApi?.getColumn(col.colId);
                const colDef = column?.getColDef();
                let flexVal = col.flex;
                if ((flexVal === undefined || flexVal === null) && colDef && colDef.flex !== undefined && colDef.flex !== null) {
                  flexVal = colDef.flex;
                }
                return {
                  ...col,
                  flex: (flexVal !== undefined && flexVal !== null) ? flexVal : null, 
                };
              });

              // Store in memory — doRecalculateColumnWidth re-applies this
              // after every setColumnDefs call so order is never lost
              this.lastRestoredState = sanitized;

              this.applyColumnOrder(sanitized);
            }
          } catch (e) {
            console.warn('Failed to parse saved column state', e);
          } finally {
            // Use setTimeout(0) so AG-Grid's internal column events from
            // applyColumnState have fired before we unlock the guard
            setTimeout(() => {
              this.isRestoringState = false;
            }, 0);
          }
        },
        error: () => {
          this.isRestoringState = false;
        },
      });
  }

  // ─── Column state: apply (used by both restore and recalculate) ───────────

  private applyColumnOrder(colState: ColumnState[]): void {
    // Step 1: Apply width, hide, pinned, sort — everything except order
    this.gridColumnApi.applyColumnState({
      state: colState,
      applyOrder: true,
    });

    // Step-2: Force column order explicitly via moveColumn.
    // applyOrder alone is unreliable after setColumnDefs rebuilds the
    // internal column model from scratch (static colDefs order).
    const allColumns = this.gridColumnApi.getAllGridColumns();
    const existingColIds = new Set(allColumns.map(c => c.getColId()));
    const validIds = colState
      .map(c => c.colId)
      .filter(id => existingColIds.has(id));

    validIds.forEach((colId, index) => {
      this.gridColumnApi.moveColumn(colId, index);
    });
  }

  // ─── Column state: persist ────────────────────────────────────────────────

  persistColumnState(): void {
    if (!this.dataModel?.storageName) {
      return;
    }

    const rawState: ColumnState[] = this.gridColumnApi.getColumnState();

    // Normalize: clear flex on non-spacer columns before saving
    const cleanState = rawState.map(col => {
      const column = this.gridColumnApi?.getColumn(col.colId);
      const colDef = column?.getColDef();
      let flexVal = col.flex;
      if ((flexVal === undefined || flexVal === null) && colDef && colDef.flex !== undefined && colDef.flex !== null) {
        flexVal = colDef.flex;
      }
      return {
        ...col,
        flex: (flexVal !== undefined && flexVal !== null) ? flexVal : null,
      };
    });

    // Keep in-memory state in sync when user drags — so the next
    // recalculateColumnWidth re-applies the latest user order
    this.lastRestoredState = cleanState;

    this.agGridService
      .saveColumnDefinition({
        gridName: this.dataModel.storageName,
        colState: JSON.stringify(cleanState),
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  // ─── Column width recalculation ───────────────────────────────────────────

  recalculateColumnWidth() {
    // Push to subject — debounce(150) collapses rapid consecutive calls
    this.recalculateColumnWidth$.next();
  }

  private doRecalculateColumnWidth(): void {
    if (!this.gridApi || !this.gridColumnApi || !this.dataModel?.colDefs) return;

    this.deviceWidth = window.innerWidth;
    const percentageWidth = this.deviceWidth > 1800 ? 15.6 : 15.4;
    const newMinWidthPixels = this.deviceWidth < 1200
      ? 300
      : Math.round((percentageWidth / 100) * this.deviceWidth);

    const stateUpdates: ColumnState[] = [];
    if (this.gridColumnApi.getColumn('companyName')) {
      stateUpdates.push({ colId: 'companyName', width: newMinWidthPixels, flex: 0 });
    }
    if (this.gridColumnApi.getColumn('vendorName')) {
      stateUpdates.push({ colId: 'vendorName', width: newMinWidthPixels, flex: 0 });
    }

    if (stateUpdates.length > 0) {
      this.gridColumnApi.applyColumnState({ state: stateUpdates });
    }
    this.updateGridView();
  }

  // ─── Grid events ──────────────────────────────────────────────────────────

  onGridSizeChanged(params: GridSizeChangedEvent) {
    this.deviceWidth = window.innerWidth;
    this.recalculateColumnWidth();
  }

  @HostListener('window:resize', ['$event'])
  sizeChange(event) {
    this.deviceWidth = event.target.innerWidth;
    this.recalculateColumnWidth();
    this.updateGridView();
  }

  updateGridView() {
    this.responsiveService.updateGridView(
      this.deviceWidth, this.gridApi, this.gridColumnApi, this.dataModel?.storageName
    );
  }

  onColumnResized(event: ColumnResizedEvent) {
    if (event.source === 'uiColumnDragged') {
      if (this.isRestoringState || this.isApplyingColumnDefs) return;
      this.columnStateChange$.next();
    }
  }

  onDragStopped(event: DragStoppedEvent) {
    this.agGridService.onColumnDragStopped.next(event);
    this.updateUserSetting(event);

    // Single source of truth for column reorder saves — columnMoved fires
    // hundreds of times during drag; onDragStopped fires exactly once
    if (this.isRestoringState || this.isApplyingColumnDefs) return;
    this.columnStateChange$.next();
  }

  // Intentionally empty — save is handled by onDragStopped only
  columnMoved(event) { }

  onFirstDataRendered(params: { api: GridApi; columnApi: ColumnApi }) {
    this.agGridService.saveColumnState(params.columnApi);
  }

  onRowClicked(params) {
    this.onRowClick.emit(params);
  }

  onRowDoubleClicked(event: any) {
    this.rowDoubleClicked.emit(event);
  }

  onSelectionChanged(event: SelectionChangedEvent) {
    this.onSelectionChange.emit(event);
    if (!this.handleCustomHeaderDisplay) return;
    this.agGridService.selectionChanged.next(event);
  }

  // ─── Document event handlers ──────────────────────────────────────────────

  expandableIconClickEvent(event: any): void {
    if (event != undefined) this.expandableIconClick.emit(event);
  }
  handleTextCellClick(event: any): void {
    if (event != undefined) this.onTextCellClick.emit(event.detail.data);
  }
  handleDeleteButtonClick(event: any): void {
    if (event != undefined) this.onDeleteIconClick.emit(event);
  }
  handleEditIconClick(event: any): void {
    if (event != undefined) this.onEditIconClick.emit(event);
  }
  handleRatingIconClick(event: any): void {
    if (event != undefined) this.onRatingIconClick.emit(event?.detail?.data);
  }
  handleSwitchIconClick(event: any): void {
    if (event != undefined) this.onSwitchIconClick.emit(event?.detail?.data);
  }
  handleSplitLineClick(event: any): void {
    if (event != undefined) this.onSplitLineClick.emit(event?.detail?.data);
  }
  handleSelectOptionClick(event: any): void {
    if (event != undefined) this.onSelectOptionClick.emit(event?.detail?.data);
  }
  handleInputChangeClick(event: any): void {
    if (event != undefined) this.onInputChangeClick.emit(event);
  }
  handleImageIconClick(event: any): void {
    if (event != undefined) this.onImageIconClick.emit(event);
  }
  handleSerialNumberClick(event: any): void {
    if (event != undefined) this.onSerialNumberClick.emit(event);
  }
  handleLinkCellClick(event: any): void {
    if (event != undefined) this.onLinkCellClick.emit(event);
  }
  handleCreatePartClick(event: any): void {
    if (event != undefined && event?.detail?.gridId === this.dataModel?.storageName)
      this.onCreatePartClick.emit(event);
  }
  handleApproveAltClick(event: any): void {
    if (event != undefined && event?.detail?.gridId === this.dataModel?.storageName)
      this.onApproveAltClick.emit(event);
  }
  handleAddExchangeRateClick(event: any): void {
    if (event != undefined && event?.detail?.gridId === this.dataModel?.storageName)
      this.onAddExchangeRateClick.emit(event);
  }
  handleResultActionClick(event: any): void {
    if (event != undefined && event?.detail?.gridId === this.dataModel?.storageName)
      this.onResultActionClick.emit(event);
  }
  handleLineStatusClick(event: any): void {
    if (event != undefined) this.onLineStatusClick.emit(event);
  }
  handleAddRFQClick(event: any): void {
    if (event != undefined) this.onAddRFQClick.emit(event.detail.data);
  }
  handleRemoveRFQClick(event: any): void {
    if (event != undefined) this.onRemoveRFQClick.emit(event.detail.data);
  }
  handleConfirmPriorityQty(event: any): void {
    if (event != undefined) this.onConfirmPriorityQty.emit(event.detail.data);
  }
  handleToggleApproveChange(event: any): void {
    if (event != undefined) this.onToggleApproveChange.emit(event.detail);
  }

  // ─── Row height ───────────────────────────────────────────────────────────

  getRowHeight(params: RowHeightParams): number | undefined | null {
    const filteredColumnNames = [
      GridName.LINEINFORMATION, GridName.REQUEST_VENDOR,
      GridName.CONFIRM_SELECTION, GridName.SEND_REQUEST,
      GridName.REQUIREMENT_SOURCES_GRID,
    ];
    let api: any = params?.columnApi;
    const filteredColumns = api?.columnModel?.columnDefs?.some(
      (column) => filteredColumnNames.includes(column?.storageName)
    );
    const isSourcingExpandable = api?.columnModel?.columnDefs?.some(
      (column) => column?.cellRendererParams?.isSourcing
    );
    if (filteredColumns) return 40;
    else if (isSourcingExpandable && params.data.isExpandable) return 172;
    else return params.data.isExpandable ? 245 : 32;
  }

  // ─── Pagination ───────────────────────────────────────────────────────────

  paginationCall() {
    this.subscription = this.agGridService.getPaginationData().subscribe(res => {
      if (res) {
        this.storageService.store(GridName.AG_GRID_PAGINATIONMODEL, undefined);
        this.tablePaginationModel = res;
        this.onPagination.emit(this.tablePaginationModel);
        this.isInitialCall = true;
      }
    });
    this.agGridService.tablePaginationData.subscribe(res => {
      if (res) {
        this.storageService.store(GridName.AG_GRID_PAGINATIONMODEL, undefined);
        this.tablePaginationModel = res;
        setTimeout(() => {
          this.onPagination.emit(this.tablePaginationModel);
        }, 100);
        this.isInitialCall = true;
      }
    });
  }

  onPageSizeChanged(index) {
    this.agGridPaginationConfig.pageNumber = 1;
    this.tablePaginationModel.pageSize = this.agGridPaginationConfig.pageSize;
    this.tablePaginationModel.pageNumber = this.agGridPaginationConfig.pageNumber;
    this.tablePaginationModel.getAll = this.agGridPaginationConfig.pageSize == 1 ? true : false;
    this.tablePaginationModel.stage = this.agGridService.getStage();
    this.onPagination.emit(this.tablePaginationModel);
  }

  onPageSizeChange(pageSize: number) {
    if (GridName.CODECROSSWALK == this.dataModel?.storageName) {
      this.requestCodecrosswalk();
    } else {
      this.onPageSizeChanged(pageSize);
    }
    this.agGridService.toggleHeaderExpandIcon.next(false);
  }

  onPageNumberChanged(index) {
    this.agGridPaginationConfig.currentPageNumber = index;
    this.tablePaginationModel.pageSize = this.agGridPaginationConfig.pageSize;
    this.tablePaginationModel.pageNumber = this.agGridPaginationConfig.currentPageNumber;
    this.tablePaginationModel.getAll = this.agGridPaginationConfig.pageSize == 1 ? true : false;
    this.tablePaginationModel.stage = this.agGridService.getStage();
    this.onPagination.emit(this.tablePaginationModel);
  }

  onPageChanged(pageNum: number) {
    if (GridName.CODECROSSWALK == this.dataModel?.storageName) {
      this.agGridPaginationConfig.currentPageNumber = pageNum;
      this.requestCodecrosswalk();
    } else {
      this.onPageNumberChanged(pageNum);
    }
    this.agGridService.toggleHeaderExpandIcon.next(false);
  }

  updatePaginationData(item, totalRecords) {
    this.agGridPaginationConfig.totalRecords = totalRecords;
    this.agGridPaginationConfig.currentPageNumber =
      this.agGridPaginationConfig.pageNumber = item?.pageNumber;
    this.agGridPaginationConfig.pageSize = item?.pageSize;
    const totalPages = Math.ceil(
      this.agGridPaginationConfig?.totalRecords / item?.pageSize
    );
    this.agGridService.totalPages = totalPages > 1;
  }

  // ─── User settings ────────────────────────────────────────────────────────

  updateUserSetting(event) {
    const grid = event?.columnApi?.columnModel?.gridColumns;
    const filteredColumns = grid
      .filter((column) => column?.colDef)
      .map((column) => column.colDef);
    const data = filteredColumns;

    this.userSetting = this.storageService.retrieve('userSetting');

    const gridUserSettingMap = {
      [this.gridName.LEADS]: 'leads',
      [this.gridName.COMPANIES]: 'companies',
      [this.gridName.CUSTOMERS]: 'customers',
      [this.gridName.PROSPECTS]: 'prospects',
      [this.gridName.CONTACTS]: 'contacts',
      [this.gridName.VENDORLISTS]: 'vendorLists',
      [this.gridName.VENDORCONTACTS]: 'vendorContacts',
      [this.gridName.REQUIREMENTS]: 'requirementLists',
      [this.gridName.PARTLIST]: 'partlists',
      [this.gridName.INSTOCK]: 'instocks',
      [this.gridName.ALLOCATION]: 'allocations',
      [this.gridName.PENDING]: 'pendings',
      [this.gridName.QUARANTINE]: 'quarantine',
      [this.gridName.CONSIGNMENT]: 'consigment',
      [this.gridName.HISTORY]: 'history',
      [this.gridName.VENDOR_PARTS_LIBRARY]: 'vendorPartsLibrary',
      [this.gridName.OEM_EXCESS_MANAGER]: 'oemExcessManager',
    };

    const settingKey = gridUserSettingMap[this.dataModel?.storageName];
    if (settingKey) {
      this.userSetting[settingKey] = data.map((a: any, index: number) => ({
        name: a.field == undefined ? '' : a.field,
        index: index + 1,
      }));
    }

    this.saveUserSetting.userSetting = JSON.stringify(this.userSetting);
    if (!this.userSetting) return;
    this.agGridService.saveUserSetting(this.saveUserSetting).subscribe(res => {
      const json = JSON.parse(res?.response);
      this.storageService.store('userSetting', json);
    });
  }

  // ─── Misc ─────────────────────────────────────────────────────────────────

  getAllArchivedCompanies() {
    this.agGridPaginationConfig.rows = [];
    this.isLoading = true;
    this.agGridService.GetAllArchivedCompanies(this.tablePaginationModel)
      .pipe(catchError((err) => this.handleError(err)))
      .subscribe((data: Result) => {
        if (data.isSuccess === true) {
          this.agGridService.agGridPaginationConfigRes.next(
            this.agGridService.updateTableData(data)
          );
          this.isLoading = false;
          this.agGridService.getGridApi().showNoRowsOverlay();
          this.agGridService.selectionChanged.next(
            this.agGridService.getGridApi().getSelectedRows()
          );
        }
      });
  }

  crosswalkDatatable() {
    this.paginationBaseModel = {
      getAll: this.agGridPaginationConfig.pageSize == 1 ? true : false,
      pageNumber: this.agGridPaginationConfig.currentPageNumber,
      pageSize: this.agGridPaginationConfig.pageSize,
      searchText: this.agGridPaginationConfig.searchText,
      sortColumn: '',
      sortDirection: '',
    };
    this.storageService.store(GridName.AG_GRID_PAGINATIONMODEL, this.paginationBaseModel);
  }

  initDatatable() {
    if (GridName.CODECROSSWALK == this.dataModel?.storageName) {
      this.crosswalkDatatable();
    } else {
      this.tablePaginationModel = {
        sortColumn: '',
        sortDirection: '',
        pageNumber: this.agGridPaginationConfig.currentPageNumber,
        pageSize: this.agGridPaginationConfig.pageSize,
        searchText: this.agGridPaginationConfig.searchText,
        getAll: this.agGridPaginationConfig.pageSize == 1 ? true : false,
        id: this.tablePaginationModel.id,
        isActive: this.tablePaginationModel.isActive,
        companyOrVendorId: '',
        documentTypeId: 0,
        stage: this.agGridService.getStage(),
        filters: '',
        selectedId: [],
        exportAsPdf: true,
        companyId: '',
        categoryId: '0',
        filtersFromPopup: '',
        searchCompanyText: this.tablePaginationModel.searchCompanyText,
      };
      this.tablePaginationModelContact = {
        sortColumn: '',
        sortDirection: '',
        pageNumber: this.agGridPaginationConfig.currentPageNumber,
        pageSize: this.agGridPaginationConfig.pageSize,
        searchText: this.agGridPaginationConfig.searchText,
        getAll: this.agGridPaginationConfig.pageSize == 1 ? true : false,
        id: this.tablePaginationModel.id,
        filters: '',
        filtersFromPopup: this.agGridService.getFilter(),
      };
      this.storageService.store(GridName.AG_GRID_PAGINATIONMODEL, this.tablePaginationModel);
    }
  }

  handleError(err: any): any {
    if (this.isLoading) {
      this.isLoading = false;
    }
  }

  requestCodecrosswalk() {
    this.paginationBaseModel.pageSize = this.agGridPaginationConfig.pageSize;
    this.paginationBaseModel.pageNumber = this.agGridPaginationConfig.currentPageNumber;
    this.paginationBaseModel.getAll = this.agGridPaginationConfig.pageSize == 1 ? true : false;
    this.onPagination.emit(this.paginationBaseModel);
  }

  showLoading(params) {
    setTimeout(() => { params?.api.showLoadingOverlay(); }, 0);
  }

  hideLoading(params) {
    params?.api?.hideOverlay();
  }

  Customizer(val) {
    this.customizer = val;
    this.agGridColumnsSettingService.isCustomizerLayoutOpen.next({ state: val, storageName: this.dataModel?.storageName });
  }

  getScreenWidth(): Observable<number> {
    return this.screenWidth$.asObservable();
  }

  rowSelected(event) { }

  public rowClassRules: RowClassRules = {
    'border-0': (params) => params.data.isExpandable == false,
    'row-border': (params) => params.data.isExpandable == true,
    'expandable-grid': (params) => params.data.isExpandable == true,
    'custom-row-style': (params) => params.data.isExpandable == true,
    'highlight-row': (params) => params.data?.highlight === true,
  };

  // ─── Destroy ──────────────────────────────────────────────────────────────

  ngOnDestroy() {
    // Remove all document event listeners — prevents memory leaks
    // when the component is destroyed (tab closed, navigation, etc.)
    this.boundHandlers.forEach(({ event, handler }) => {
      document.removeEventListener(event, handler);
    });
    this.boundHandlers = [];

    if (this.subscription != undefined) {
      this.subscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
